import useSWR from 'swr';

import { IDetailResponse, IPaginatedResponse, ISimpleListResponse } from 'utils/types';

import { fetcher } from './utils';

export interface IAudienceUserGroup {
  id?: number;
  name: string;
  list_type: string;
}

export interface IAudience {
  id: number;
  name: string;
  state?: string;
  filters?: any;
  user_groups?: IAudienceUserGroup[];
  user_account_counts?: number | null;
  last_counted_at?: string | null;
  created_at?: string;
  updated_at?: string;
  auto_create_customers?: boolean;
}

export interface ISimpleAudience {
  id: number;
  name: string;
}

export const useAudienceList = (params?: Record<string, any>, shouldFetch: boolean = true) => {
  const key = shouldFetch ? { url: '/v4/dash/v4_audiences', params } : null;

  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<IAudience>>(
    key,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};

export const useAudience = (id?: number | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<IAudience>>(
    id ? `/v4/dash/v4_audiences/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};

export const useSimpleAudienceList = (params: Record<string, any> = { size: 1000 }) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<
    ISimpleListResponse<ISimpleAudience>
  >({ url: '/v4/dash/simple/audiences', params }, fetcher);

  return { data: data?.data, isLoading, error, mutate, isValidating };
};
